// import React, { useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import { useOrderDetailsQuery } from "../../redux/api/orderApi";
// import Loader from "../layout/Loader";
// import MetaData from "../layout/MetaData";
// import toast from "react-hot-toast";
// import html2canvas from "html2canvas";
// import { jsPDF } from "jspdf";

// const Receipt = () => {
//   const params = useParams();
//   const { data, error, isLoading } = useOrderDetailsQuery(params?.id);

//   useEffect(() => {
//     if (error) {
//       toast.error(error?.data?.message || "Failed to fetch order details");
//     }
//   }, [error]);

//   const handleDownload = () => {
//     const input = document.getElementById("order_receipt");
  
//     html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
  
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = pdf.internal.pageSize.getHeight();
  
//       // scale image to fit page width
//       const imgWidth = pdfWidth;
//       const imgHeight = (canvas.height * pdfWidth) / canvas.width;
  
//       let heightLeft = imgHeight;
//       let position = 0;
  
//       // Add first page
//       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//       heightLeft -= pdfHeight;
  
//       // Add extra pages if needed
//       while (heightLeft > 0) {
//         position = heightLeft - imgHeight;
//         pdf.addPage();
//         pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//         heightLeft -= pdfHeight;
//       }
  
//       pdf.save(`receipt_${order?._id}.pdf`);
//     });
//   };
  

//   if (isLoading) return <Loader />;

//   const order = data?.order || {};
//   const {
//     shippingInfo,
//     orderItems,
//     paymentInfo,
//     user,
//     totalAmount,
//     orderStatus,
//   } = order;

//   const generateInvoiceNumber = (orderId, createdAt) => {
//     const date = new Date(createdAt);
//     return `${date.getFullYear()}-${orderId?.slice(-2).toUpperCase()}`;
//   };

//   return (
//     <>
//       <MetaData title={`Receipt #${order?._id}`} />
//   {/* Print Button */}
//   <div className="text-center mt-10">
//           <button onClick={handleDownload}
//             className="inline-block bg-yellow-950 text-white px-6 py-3 rounded-xl shadow-md hover:bg-yellow-800 transition"
//           >
//             <i className="fa fa-print mr-2"></i> Print Receipt
//           </button>
//         </div>
//       <section
//         id="order_receipt"
//         className="max-w-4xl mt-6 mx-auto px-6 py-10 font-sourcesans bg-white rounded-2xl shadow-lg"
//       >
//         {/* Header */}
//         <div className="text-center mb-10">
//           <h2 className="text-3xl sm:text-4xl font-playfair text-amber-700 font-bold">
//             <Link to={"/"}>sanguine accent</Link>
//           </h2>
//           <h1 className="text-2xl font-semibold text-yellow-950 mt-4">
//             Receipt #{generateInvoiceNumber(order?._id, order?.createdAt)}
//           </h1>
//           <p className="text-stone-600 mt-2">
//             Order Date:{" "}
//             <span className="font-medium">
//               {new Date(order?.createdAt).toLocaleString("en-US")}
//             </span>
//           </p>
//         </div>

//         {/* Billing + Shipping Info */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
//           <div className="bg-stone-50 p-5 rounded-xl border">
//             <h3 className="text-lg font-playfair text-yellow-950 mb-2">
//               Customer
//             </h3>
//             <p className="text-stone-700">{user?.name}</p>
//             <p className="text-stone-700">{user?.email}</p>
//             <p className="text-stone-700">{shippingInfo?.phoneNo}</p>
//           </div>
//           <div className="bg-stone-50 p-5 rounded-xl border">
//             <h3 className="text-lg font-playfair text-yellow-950 mb-2">
//               Shipping Address
//             </h3>
//             <p className="text-stone-700">{shippingInfo?.address}</p>
//             <p className="text-stone-700">
//               {shippingInfo?.city}, {shippingInfo?.region},{" "}
//               {shippingInfo?.zipCode}, {shippingInfo?.country}
//             </p>
//           </div>
//         </div>

//         {/* Ordered Items */}
//         <div className="mb-10">
//           <h3 className="text-xl font-playfair text-yellow-950 mb-4">Items</h3>
//           <div className="overflow-x-auto">
//             <table className="w-full border border-stone-300 rounded-lg overflow-hidden">
//               <thead>
//                 <tr className="bg-amber-100 text-left">
//                   <th className="px-4 py-3 font-semibold">Product</th>
//                   <th className="px-4 py-3 font-semibold">Qty</th>
//                   <th className="px-4 py-3 font-semibold">Price</th>
//                   <th className="px-4 py-3 font-semibold">Total</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {orderItems?.map((item, idx) => (
//                   <tr
//                     key={item?._id}
//                     className={idx % 2 === 0 ? "bg-white" : "bg-stone-50"}
//                   >
//                     <td className="px-4 py-3">{item?.name}</td>
//                     <td className="px-4 py-3">{item?.quantity}</td>
//                     <td className="px-4 py-3">${item?.price}</td>
//                     <td className="px-4 py-3 font-medium">
//                       ${item?.quantity * item?.price}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Payment Summary */}
//         <div className="bg-stone-50 p-6 rounded-xl border text-right">
//           <p className="text-stone-700 mb-2">
//             <span className="font-semibold">Payment Status:</span>{" "}
//             <span
//               className={`px-3 py-1 rounded-md text-sm font-medium ${
//                 paymentInfo?.status === "paid"
//                   ? "bg-green-100 text-green-700"
//                   : "bg-red-100 text-red-700"
//               }`}
//             >
//               {paymentInfo?.status?.toUpperCase()}
//             </span>
//           </p>
//           <p className="text-stone-700 mb-2">
//             <span className="font-semibold">Payment ID:</span>{" "}
//             {paymentInfo?.id || "N/A"}
//           </p>
//           <p className="text-xl font-bold text-yellow-950">
//             Total: ${totalAmount}
//           </p>
//           <p className="text-stone-700 mt-2">
//             <span className="font-semibold">Order Status:</span> {orderStatus}
//           </p>
//         </div>

      
//       </section>
//     </>
//   );
// };

// export default Receipt;

import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useOrderDetailsQuery } from "../../redux/api/orderApi";
import Loader from "../layout/Loader";
import toast from "react-hot-toast";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { Helmet } from "react-helmet-async";

const Receipt = () => {
  const params = useParams();
  const { data, error, isLoading } = useOrderDetailsQuery(params?.id);

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message || "Failed to fetch order details");
    }
  }, [error]);

  const order = data?.order || {};
  const { shippingInfo, orderItems, paymentInfo, user, totalAmount, orderStatus } = order;

  const generateInvoiceNumber = (orderId, createdAt) => {
    const date = new Date(createdAt);
    return `INV-${date.getFullYear()}-${orderId?.slice(-4).toUpperCase()}`;
  };

  const handleDownload = () => {
    const input = document.getElementById("order_receipt");
    html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdf.internal.pageSize.getHeight();
      }

      pdf.save(`receipt_${order?._id}.pdf`);
    });
  };

  if (isLoading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>Receipt</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Action Buttons */}
      <div className="text-center mt-20 py-11 md:mt-48  flex justify-center gap-4">
        <button
          onClick={handleDownload}
          className="bg-[#BC3F4A] text-white px-6 py-3 rounded-lg shadow hover:bg-[#a3323b] transition"
        >
          <i className="fa fa-file-pdf mr-2"></i> Download PDF
        </button>
        <button
          onClick={() => window.print()}
          className="bg-stone-700 text-white px-6 py-3 rounded-lg shadow hover:bg-stone-800 transition"
        >
          <i className="fa fa-print mr-2"></i> Print
        </button>
      </div>

      {/* Receipt */}
      <section
        id="order_receipt"
        className="max-w-4xl mt-6 mx-auto px-6 py-10 font-sourcesans bg-white rounded-xl border border-stone-200 shadow-md print:shadow-none print:border-none"
      >
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl sm:text-4xl font-playfair text-[#BC3F4A] font-bold">
            <Link to={"/"}>Sanguine Accent</Link>
          </h2>
          <h1 className="text-xl sm:text-2xl font-semibold text-yellow-950 mt-4">
            Receipt #{generateInvoiceNumber(order?._id, order?.createdAt)}
          </h1>
          <p className="text-stone-600 mt-2">
            Order Date:{" "}
            <span className="font-medium">
              {new Date(order?.createdAt).toLocaleString("en-US")}
            </span>
          </p>
        </div>

        {/* Customer & Shipping */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          <div className="bg-stone-50 p-5 rounded-lg border">
            <h3 className="text-lg font-playfair text-yellow-950 mb-2">Customer</h3>
            <p className="text-stone-700">{user?.name}</p>
            <p className="text-stone-700">{user?.email}</p>
            <p className="text-stone-700">{shippingInfo?.phoneNo}</p>
          </div>
          <div className="bg-stone-50 p-5 rounded-lg border">
            <h3 className="text-lg font-playfair text-yellow-950 mb-2">Shipping Address</h3>
            <p className="text-stone-700">{shippingInfo?.address}</p>
            <p className="text-stone-700">
              {shippingInfo?.city}, {shippingInfo?.region},{" "}
              {shippingInfo?.zipCode}, {shippingInfo?.country}
            </p>
          </div>
        </div>

        {/* Items */}
        <div className="mb-10">
          <h3 className="text-xl font-playfair text-yellow-950 mb-4">Items</h3>
          <div className="overflow-x-auto">
            <table className="w-full border border-stone-300 text-sm sm:text-base">
              <thead>
                <tr className="bg-amber-100 text-left">
                  <th className="px-4 py-3 font-semibold">Product</th>
                  <th className="px-4 py-3 font-semibold">Qty</th>
                  <th className="px-4 py-3 font-semibold">Price</th>
                  <th className="px-4 py-3 font-semibold text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {orderItems?.map((item, idx) => (
                  <tr key={item?._id} className={idx % 2 === 0 ? "bg-white" : "bg-stone-50"}>
                    <td className="px-4 py-3">{item?.name}</td>
                    <td className="px-4 py-3">{item?.quantity}</td>
                    <td className="px-4 py-3">${item?.price}</td>
                    <td className="px-4 py-3 font-medium text-right">
                      ${(item?.quantity * item?.price).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Summary */}
        <div className="bg-stone-50 p-6 rounded-lg border text-right">
          <p className="text-stone-700 mb-2">
            <span className="font-semibold">Payment Status:</span>{" "}
            <span
              className={`px-3 py-1 rounded-md text-sm font-medium ${
                paymentInfo?.status === "paid" || paymentInfo?.status === "succeeded"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {paymentInfo?.status?.toUpperCase() || "UNPAID"}
            </span>
          </p>
          <p className="text-stone-700 mb-2">
            <span className="font-semibold">Payment ID:</span> {paymentInfo?.id || "N/A"}
          </p>
          <p className="text-xl font-bold text-yellow-950">Total: ${totalAmount?.toFixed(2)}</p>
          <p className="text-stone-700 mt-2">
            <span className="font-semibold">Order Status:</span> {orderStatus}
          </p>
        </div>
      </section>
    </>
  );
};

export default Receipt;

